module.exports = __webpack_public_path__ + "static/media/CACERVEG_MENU-normal.1389900b.png";